import React, { useState, useEffect, useRef } from "react";

const TruncatedText = ({ text, maxLines = 2 }) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      // check if content overflows
      const hasOverflow = textRef.current.scrollHeight > textRef.current.clientHeight;
      setIsTruncated(hasOverflow);
    }
  }, [text, maxLines]);

  return (
    <div>
      <div
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "unset" : maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: expanded ? "normal" : "initial",
          cursor: isTruncated ? "pointer" : "default",
        }}
        onClick={() => isTruncated && setExpanded(!expanded)}
      >
        {text}
      </div>

      {isTruncated && !expanded && (
        <span
          onClick={() => setExpanded(true)}
          style={{ color: "#1381B5", cursor: "pointer", fontSize: "12px" }}
        >
          ...Read more
        </span>
      )}
      {expanded && (
        <span
          onClick={() => setExpanded(false)}
          style={{ color: "#1381B5", cursor: "pointer", fontSize: "12px" }}
        >
          Show less
        </span>
      )}
    </div>
  );
};

export default TruncatedText;